import React from 'react';
import { SignalStrengthHelper } from '../../helpers';
import config from "config";

const findPrimaryNonOnlineMeasurementsByDisplayOrder = (measurements) => {
  return measurements.filter((measurement) => measurement.lastReceivedData?.deviceDataType?.primary && measurement.lastReceivedData?.deviceDataType?.token != 'online')
                     .sort((measurementA, measurementB) => measurementA.lastReceivedData?.deviceDataType?.displayOrder - measurementB.lastReceivedData?.deviceDataType?.displayOrder)
}

const EntityIcon = ({ entity, healthStatusOverride, ...other }) => {
  var imageURL = entity.primaryDeviceTypeToken ? 
                          `${config.WEB_BASE_URL}/images/icon/sensor_${entity.primaryDeviceTypeToken}_normal.svg` :
                          `${config.WEB_BASE_URL}/images/icon/sensor_${entity.statusToken}.svg`;

  if (healthStatusOverride) {
    if (entity.statusToken != 'active') {
      imageURL = `${config.WEB_BASE_URL}/images/icon/sensor_${entity.statusToken}.svg`;
    } else {
      if (!entity.online) {
        imageURL = `${config.WEB_BASE_URL}/images/icon/sensor_device_offline.svg`;
      } else {
        imageURL = `${config.WEB_BASE_URL}/images/icon/sensor_rssi_${SignalStrengthHelper.renderFirstRating(entity)}.svg`;
      }
    }
  } else {
    const firstActivePrimaryMeasurement = findPrimaryNonOnlineMeasurementsByDisplayOrder(entity.currentMeasurements)
                                                .find((measurement) => measurement.originatingDeviceStatusToken === "active");

    if (firstActivePrimaryMeasurement) {
        if (firstActivePrimaryMeasurement.lastReceivedData?.deviceDataType?.deviceDataClassification?.token) {
            imageURL = `${config.WEB_BASE_URL}/images/icon/sensor_${firstActivePrimaryMeasurement.lastReceivedData?.deviceDataType?.deviceDataClassification?.token}_normal.svg`;
        } else {
            imageURL = `${config.WEB_BASE_URL}/images/icon/sensor_${firstActivePrimaryMeasurement.originatingDeviceDataTypeToken}_normal.svg`;
        }
    }

    if (entity.statusToken != 'active') {
      imageURL = `${config.WEB_BASE_URL}/images/icon/sensor_${entity.statusToken}.svg`;
    } else if (entity.thresholdsExceeded?.length > 0) {
      imageURL = `${config.WEB_BASE_URL}/images/icon/sensor_${entity.thresholdsExceeded[0].thresholdClassification.token}.svg`;
    }
  }

  return ( <img {...other} src={imageURL} /> );
}

export default EntityIcon;